(function ($) {

  const $body = $('body');
  const $header = $('#site-header');
  const $menu = $('#menu-wrap');
  const $toggle = $('#mobile-menu-toggle');
  const $nav = $('#header-nav-container');
  const speed = 300;

  const menu_bp = $header.data('menu-bp');


  function is_mobile() {
    return $header.hasClass('mobile');
  }


  const focus_trap = focusTrap.createFocusTrap($header.get(0), {
    onActivate() {
      $toggle.addClass('is-active');
      $menu.addClass('visible');
      $body.addClass('menu-open');
    },
    onDeactivate() {
      $toggle.removeClass('is-active');
      $body.removeClass('menu-open');
      setTimeout(function () {
        $menu.removeClass('visible');
      }, speed);
    },
    initialFocus: $toggle.get(0),
  });


  function get_viewport_rect() {
    return {
      left: 0,
      right: window.innerWidth,
    };
  }


  function get_submenu_for_item($li) {
    let $btn = $('> .link-wrap button.sub-menu-toggle', $li);
    if (!$btn.length) { return $(); }
    return $(`#${$btn.attr('aria-controls')}`);
  }


  function is_flyout_submenu($submenu) {
    return $submenu.parent().closest('ul.sub-menu').length > 0;
  }


  function get_submenu_width($submenu) {
    let width = $submenu.outerWidth();
    if (width) { return width; }
    return parseFloat($submenu.css('width')) || 270;
  }


  function get_top_level_submenu_offset($li) {
    let gutter = parseFloat(window.getComputedStyle($li.parent()[0]).getPropertyValue('--bs-gutter-x'));
    if (Number.isNaN(gutter)) {
      gutter = parseFloat(window.getComputedStyle($li[0]).getPropertyValue('--bs-gutter-x'));
    }
    return Number.isNaN(gutter) ? 0 : gutter / 2;
  }


  function calculate_flip_for_item($li) {
    let $submenu = get_submenu_for_item($li);
    if (!$submenu.length) { return; }

    $submenu.removeClass('sub-menu-flip-x');

    let liRect = $li[0].getBoundingClientRect();
    if (!liRect.width || !liRect.height) { return; }

    let viewport = get_viewport_rect();
    let submenuWidth = get_submenu_width($submenu);
    let isFlyout = is_flyout_submenu($submenu);

    if (isFlyout) {
      let opensRight = liRect.right + submenuWidth;
      let opensLeft = liRect.left - submenuWidth;
      let overflowRight = opensRight > viewport.right;
      let overflowLeft = opensLeft < viewport.left;

      if (overflowRight && !overflowLeft) {
        $submenu.addClass('sub-menu-flip-x');
      } else if (overflowRight && overflowLeft) {
        let spaceRight = viewport.right - liRect.right;
        let spaceLeft = liRect.left - viewport.left;
        if (spaceLeft >= spaceRight) {
          $submenu.addClass('sub-menu-flip-x');
        }
      }
      return;
    }

    if ($li.parent().hasClass('menu')) {
      let submenuLeft = liRect.left + get_top_level_submenu_offset($li);
      if (submenuLeft + submenuWidth > viewport.right) {
        $submenu.addClass('sub-menu-flip-x');
      }
    }
  }


  function update_all_submenu_flips() {
    if (is_mobile()) {
      $nav.find('.sub-menu-flip-x').removeClass('sub-menu-flip-x');
      return;
    }

    $nav.find('li.menu-item-has-children').each(function () {
      calculate_flip_for_item($(this));
    });
  }


  function is_on_link_wrap(mouse_x, mouse_y, $li) {
    let rect = $li.find('> .link-wrap')[0].getBoundingClientRect();
    return mouse_x >= rect.left && mouse_x <= rect.right
      && mouse_y >= rect.top && mouse_y <= rect.bottom;
  }


  function is_direct_submenu_hover($li, mouse_x, mouse_y) {
    return $li.hasClass('menu-item-has-children') && is_on_link_wrap(mouse_x, mouse_y, $li);
  }


  function is_cursor_in_nav(mouse_x, mouse_y) {
    let target = document.elementFromPoint(mouse_x, mouse_y);
    return target && $(target).closest('#header-nav-container').length > 0;
  }


  function deactivate_submenu_branch($li) {
    $li.removeClass('is-submenu-active');
    $li.find('.is-submenu-active').removeClass('is-submenu-active');
    $li.find('button.sub-menu-toggle').attr('aria-expanded', 'false');
    $li.find('ul.sub-menu').attr('aria-hidden', 'true');
  }


  function deactivate_sibling_branches($li) {
    $li.siblings('.is-submenu-active').each(function () {
      deactivate_submenu_branch($(this));
    });
  }


  function close_all_cascade_menus() {
    $nav.find('.is-submenu-active').removeClass('is-submenu-active');
    $nav.find('button.sub-menu-toggle').attr('aria-expanded', 'false');
    $nav.find('ul.sub-menu').attr('aria-hidden', 'true');
  }


  function activate_cascade_item($li) {
    deactivate_sibling_branches($li);
    $li.addClass('is-submenu-active');

    let $btn = $('> .link-wrap button.sub-menu-toggle', $li);
    let $submenu = get_submenu_for_item($li);

    if ($btn.length) {
      $btn.attr('aria-expanded', 'true');
    }

    if ($submenu.length) {
      $submenu.attr('aria-hidden', 'false');
    }
  }


  function reset_submenu_styles() {
    $nav.find('ul.sub-menu').each(function () {
      $(this).attr('aria-hidden', 'true').css('display', '');
    });
    $nav.find('button.sub-menu-toggle').attr('aria-expanded', 'false');
    close_all_cascade_menus();
  }


  function init_cascade_menus() {
    $nav.off('.cascade');
    $(document).off('mousemove.cascade');
    close_all_cascade_menus();

    if (is_mobile()) { return; }

    $(document).on('mousemove.cascade', function (e) {
      if (!is_cursor_in_nav(e.clientX, e.clientY) && $nav.find('.is-submenu-active').length) {
        close_all_cascade_menus();
      }
    });

    $nav.on('mouseenter.cascade', 'li', function (e) {
      let $li = $(this);
      let x = e.clientX;
      let y = e.clientY;

      if (is_direct_submenu_hover($li, x, y)) {
        let $activeSibling = $li.siblings('.menu-item-has-children.is-submenu-active');
        if ($activeSibling.length && !$activeSibling.is($li)) {
          activate_cascade_item($li);
          return;
        }
      }

      if (!$li.hasClass('menu-item-has-children')) {
        deactivate_sibling_branches($li);
        return;
      }

      if ($li.hasClass('is-submenu-active')) { return; }

      activate_cascade_item($li);
    });

    $nav.on('mouseleave.cascade', function (e) {
      let $related = $(e.relatedTarget);
      if (!$related.closest('#header-nav-container').length) {
        close_all_cascade_menus();
      }
    });
  }


  function resize() {
    $header.toggleClass('mobile', !ThemeJS.Media_Queries.is_at_least(menu_bp));
    document.querySelector(':root').style.setProperty('--header-height', `${$header.outerHeight()}px`);
    $menu.removeClass('mobile-transition-enabled');
    setTimeout(function () {
      $menu.addClass('mobile-transition-enabled');
    }, 0);

    reset_submenu_styles();

    if (ThemeJS.Media_Queries.is_at_least(menu_bp)) {
      focus_trap.deactivate();
      init_cascade_menus();
      update_all_submenu_flips();
    } else {
      $nav.find('.sub-menu-flip-x').removeClass('sub-menu-flip-x');
    }
  }


  resize();
  $header.addClass('fixed');
  $(window).on('breakpoint_changed', resize);
  $(window).on('resize', update_all_submenu_flips);
  $header.on('main_bar_hidden.minimizeHeader', function () {
    if (!is_mobile()) {
      close_all_cascade_menus();
    }
  });

  $toggle.click(() => {
    $body.hasClass('menu-open') ? focus_trap.deactivate() : focus_trap.activate();
  });


  function set_submenu_open($li, opening) {
    let $btn = $('> .link-wrap button.sub-menu-toggle', $li);
    if (!$btn.length) { return; }
    let $submenu = $(`#${$btn.attr('aria-controls')}`);
    if (!$submenu.length) { return; }
    $btn.attr('aria-expanded', opening ? 'true' : 'false');
    $submenu.attr('aria-hidden', opening ? 'false' : 'true')[opening ? 'slideDown' : 'slideUp'](speed);
  }


  $menu.on('click', 'button.sub-menu-toggle', function (e) {
    e.preventDefault();

    if (!is_mobile()) {
      let $li = $(this).closest('li');

      if ($li.hasClass('is-submenu-active')) {
        deactivate_submenu_branch($li);
      } else {
        activate_cascade_item($li);
        update_all_submenu_flips();
      }

      return;
    }

    set_submenu_open($(this).closest('li'), $(this).attr('aria-expanded') == 'false');
  });


  $menu.on('focusout', 'li.menu-item-has-children', function (e) {
    if (is_mobile() || $.contains(this, e.relatedTarget)) { return; }
    deactivate_submenu_branch($(this));
  });


  $menu.on('click', 'a[href="#"]', function (e) {
    if (!is_mobile()) { return; }
    e.preventDefault();
    let $btn = $(this).siblings('button.sub-menu-toggle');
    if ($btn.length) {
      $btn.click();
    }
  });

})(jQuery);
